// src/components/schedule/Activities.js
import React from 'react';
import { Activity } from 'lucide-react';
import { useAtom } from 'jotai';
import { activeChildDetail } from '../../atomstore/store';
import { useRequestProcessor } from '../../requestProcessor';
import { fetchDailyFeed } from '../../queryfunctions/queryfunctions';
import SpinnerLoading from '../common/SpinnerLoading';
import moment from 'moment';
import { SERVER_DATE_FORMAT } from '../home/Home';

const Activities = ({ selectedDate }) => {
    const { useQueryWrapper } = useRequestProcessor();
    const [activeChild] = useAtom(activeChildDetail);

    const formattedDate = moment(selectedDate).format(SERVER_DATE_FORMAT);
    const dayName = moment(selectedDate).format('dddd');

    const { data: dailyFeedData, isLoading, isFetching } = useQueryWrapper(
        ['dailyFeed', 'activity' + activeChild?.id, formattedDate],
        () => fetchDailyFeed(formattedDate)
    );

    // Ensure dailyFeed is always an array
    const dailyFeed = Array.isArray(dailyFeedData) ? dailyFeedData : [];

    if (isLoading || isFetching) {
        return (
            <div className="py-12 flex justify-center">
                <SpinnerLoading />
            </div>
        );
    }
    const getDescription = (item) => {

        return item.plan_parent_text
            .replace(/amp;/g, "")
            .replace(/&amp;/g, "&")
            .replace(/&quot;/g, '"')
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&#039;/g, "'")
            .replace(/&ldquo;/g, "\u201C")
            .replace(/&rdquo;/g, "\u201D")
    }

    return (
        <div className="space-y-4">
            <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-2xl p-4 text-white">
                <h3 className="text-lg font-bold mb-1">{dayName}</h3>
                <p className="text-sm opacity-90">
                    {moment(selectedDate).format('DD MMMM YYYY')}
                </p>
            </div>

            {Array.isArray(dailyFeed) && dailyFeed.length === 0 ? (
                <div className="bg-gray-100 rounded-2xl p-8 text-center">
                    <p className="text-gray-500">
                        {moment(selectedDate).day() === 0 || moment(selectedDate).day() === 6
                            ? 'No activities on weekends'
                            : 'No activities scheduled for this day'}
                    </p>
                </div>
            ) : (
                <div className="space-y-3">
                    {dailyFeed.map((item, idx) => (
                        <div
                            key={idx}
                            className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100"
                        >
                            <div className="flex items-start space-x-3">
                                <div className="w-10 h-10 bg-gradient-to-br from-purple-400 to-pink-500 rounded-xl flex items-center justify-center flex-shrink-0">
                                    <Activity className="w-5 h-5 text-white" />
                                </div>
                                <div className="flex-1">
                                    <div className="flex items-center justify-between mb-1">
                                        <h4 className="font-bold text-gray-800">
                                            {item.plan_activity.replace(/<br>/g, "\n") || 'Untitled Activity'}
                                        </h4>
                                        {/* <span className="text-xs text-gray-500">
                                            {'10:00 AM' || '--'}
                                        </span> */}
                                    </div>
                                    <p className="text-sm text-gray-600">
                                        {typeof item.plan_parent_text === "string"
                                            ? getDescription(item).replace(/<br>/g, "\n")
                                            : "" || 'No description available'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Activities;
